import { useHotkey } from "@btnet/core-components/Hotkey/useHotkey";

import { useRequiredContext } from "helpers/globalContext/useRequiredContext";
import { UserInfoContext } from "helpers/globalContext/UserInfoContext";

import { routes } from "utilities/routes";

import { HotkeyCommands } from "commonComponents/utilities/Hotkey/hotkey.utility";

import { HotkeyDisplay } from "../HotkeyDisplay/HotkeyDisplay";

export function HotkeyDisplaySetup() {
    const userInfo = useRequiredContext(UserInfoContext);
    const hotkeyCommand = HotkeyCommands.helpCenter.command;
    const hotkeyFriendlyName = HotkeyCommands.helpCenter.friendlyName;
    const hotkeyCallback = () => {
        window.open(routes.help.getHelpCenterUrlForLoginType(userInfo.loginType), "_blank");
    };

    useHotkey({
        command: hotkeyCommand,
        friendlyName: hotkeyFriendlyName,
        onCommand: hotkeyCallback,
    });
    return <HotkeyDisplay />;
}
